import { CurrencyFormatted, Typography, FormInput, Badge } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import { Success } from '@ui/components/icons';
import { Control } from 'react-hook-form';
import { Masks } from '@helpers/constant';
import { FC } from 'react';

import { TopUpFormSchema } from '../../../hooks';

export const TopUpAmount: FC<{
  formControl: Control<TopUpFormSchema>;
  suggestedTopUpAmount?: number;
}> = ({ formControl, suggestedTopUpAmount }) => {
  const { currency } = useCurrentUser();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <Typography variant="h200" element="h2">
          {t('ONBOARDING.TOP_UP.TOP_UP_AMOUNT')}
        </Typography>

        <Badge variant="success" size="large">
          <Success />
          {t('ONBOARDING.TOP_UP.DESCRIPTION')}
        </Badge>
      </div>
      <div className="space-y-4">
        <FormInput
          componentProps={{
            maskOptions: { mask: Masks.CURRENCY_FORMAT },
            className:
              '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
          }}
          trailingIcon={{
            position: 'right',
            icon: (
              <Typography className="text-content-weak" variant="labelSmallBold">
                {currency}
              </Typography>
            ),
          }}
          placeholder={t('ONBOARDING.TOP_UP.AMOUNT')}
          formControl={formControl}
          className="max-w-69.5"
          name="amount"
          floating
        />
        <Typography variant="labelMediumBook" className="text-weak">
          {t('ONBOARDING.TOP_UP.TOP_UP_AMOUNT_HINT')}
          <Typography variant="labelMediumBold" asChild>
            <CurrencyFormatted value={suggestedTopUpAmount || 0} currency={currency} />
          </Typography>
        </Typography>
      </div>
    </div>
  );
};
